import { render } from "./OrderForm.vue?vue&type=template&id=749d388c"
import script from "./OrderForm.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./OrderForm.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script